import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import { enUS, es } from "date-fns/locale";
import React, { useContext } from "react";
import { DateRangePicker } from "react-date-range";

import {
  addDays,
  addMonths,
  differenceInCalendarDays,
  endOfDay,
  endOfMonth,
  endOfWeek,
  isSameDay,
  startOfDay,
  startOfMonth,
  startOfWeek
} from "date-fns";
import { useTranslation } from "react-i18next";
import { DateRangeContext } from "../context/DateRangeContext";
import { useZoom } from "../context/ZoomContext";

const defineds = {
  startOfWeek: startOfWeek(new Date()),
  endOfWeek: endOfWeek(new Date()),
  startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
  endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
  startOfToday: startOfDay(new Date()),
  endOfToday: endOfDay(new Date()),
  startOfYesterday: startOfDay(addDays(new Date(), -1)),
  endOfYesterday: endOfDay(addDays(new Date(), -1)),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
  startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
  endOfLastMonth: endOfMonth(addMonths(new Date(), -1))
};

const staticRangeHandler = {
  range: {},
  isSelected(range) {
    const definedRange = this.range();
    return (
      isSameDay(range.startDate, definedRange.startDate) &&
      isSameDay(range.endDate, definedRange.endDate)
    );
  }
};

function createStaticRanges(ranges) {
  return ranges.map((range) => ({ ...staticRangeHandler, ...range }));
}

export const defaultStaticRanges = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = useTranslation();

  return createStaticRanges([
    {
      label: t("hoy"),
      range: () => ({
        startDate: defineds.startOfToday,
        endDate: defineds.endOfToday
      })
    },
    {
      label: t("ayer"),
      range: () => ({
        startDate: defineds.startOfYesterday,
        endDate: defineds.endOfYesterday
      })
    },

    {
      label: t("esta_semana"),
      range: () => ({
        startDate: defineds.startOfWeek,
        endDate: defineds.endOfToday
      })
    },
    {
      label: t("semana_pasada"),
      range: () => ({
        startDate: defineds.startOfLastWeek,
        endDate: defineds.endOfLastWeek
      })
    },
    {
      label: t("este_mes"),
      range: () => ({
        startDate: defineds.startOfMonth,
        endDate: defineds.endOfToday
      })
    }
    /* {
      label: t("mes_pasado"),
      range: () => ({
        startDate: defineds.startOfLastMonth,
        endDate: defineds.endOfLastMonth
      })
    } */
  ]);
};

export const defaultInputRanges = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = useTranslation();

  return [
    {
      label: t("dias_hasta_hoy"),
      range(value) {
        return {
          startDate: addDays(
            defineds.startOfToday,
            (Math.max(Number(value), 1) - 1) * -1
          ),
          endDate: defineds.endOfToday
        };
      },
      getCurrentValue(range) {
        if (!isSameDay(range.endDate, defineds.endOfToday)) return "-";
        if (!range.startDate) return "∞";
        return (
          differenceInCalendarDays(defineds.endOfToday, range.startDate) + 1
        );
      }
    }
  ];
};

export function CustomDateRangePicker({ handleCloseDialog }) {
  const { t, i18n } = useTranslation();
  const { date, handleSelect, handleFinalDate } = useContext(DateRangeContext);
  const { setZoomRange } = useZoom();
  const staticRanges = defaultStaticRanges();
  const inputRanges = defaultInputRanges();
  const localDatosMina = JSON.parse(localStorage.getItem("dataOpMina"));
  const fecha_instalacion = localDatosMina.fecha_instalacion;

  const handleClick = () => {
    setZoomRange(null);
    handleCloseDialog();
    handleFinalDate(date);
  };

  return (
    <section
      style={{
        width: "fit-content",
        display: "flex",
        flexDirection: "column"
      }}>
      <DateRangePicker
        onChange={(item) => handleSelect(item)}
        showSelectionPreview={true}
        moveRangeOnFirstSelection={false}
        months={2}
        ranges={date}
        direction="horizontal"
        minDate={
          fecha_instalacion ?
          new Date(fecha_instalacion) :
          new Date("2025-01-02")
        }
        maxDate={new Date()}
        staticRanges={staticRanges}
        inputRanges={inputRanges}
        locale={i18n.language === "es" ? es : enUS}
      />
      <button
        className="btn-select-final-date"
        onClick={handleClick}>
        {t("seleccionar_fechas")}
      </button>
    </section>
  );
}
